import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { defineElement } from "@lordicon/element";
import { DropdownsModule } from 'src/app/core/dropdowns/dropdowns.module';
import { DxCheckBoxModule, DxDataGridModule, DxPopupModule } from 'devextreme-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridViewComponent } from './component/grid-view.component';
import lottie from 'lottie-web';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { ToastsContainer } from 'src/app/shared/toast/toasts-container.component';

@NgModule({
  declarations: [
    GridViewComponent
  ],
  imports: [
    CommonModule,
    DropdownsModule,
    DxCheckBoxModule,
    DxDataGridModule,
    DxPopupModule,
    FormsModule,
    NgbModule,
    NgSelectModule,
    ReactiveFormsModule,
    ToastsContainer
  ],
  exports: [
    GridViewComponent
  ],
  providers: [
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class GridViewModule {
  constructor() {
    defineElement(lottie.loadAnimation);
  }
}
